export const sendForm = (params) => {
    return fetch("/.netlify/functions/email", {
      method: "POST",
      body: JSON.stringify(params),
    });
  };